import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import Model from '../models/model';
import strings from '../Globalization';
import util from '../util';
import consts from '../consts';
import { saveRecord } from '../components/crud-helper';
import ActionIconButton from '../components/common/ActionIconButton';

const roleCheck = () => {
	if (consts.RoleCheck.includes(util?.getLoginData()?.roles[0])) {
		return true
	}
	else {
		return false
	}
}
const model = new Model({
	name: 'AssetsCode',
	api: 'AssetCode',
	title: 'Codes',
	pathname: '/assetscode',
	readOnly: roleCheck,
	formTitleField: 'code',
	disableDelete: true,
	disableExport: true,
	disableAdd: roleCheck,
	disableFiltering: true,
	showGridRefreshBtn: true,
	idProperty: '_id',
	customizeSaveData: (toSave, { activeRecord }) => ({ ...toSave, assetId: activeRecord.record.assetId }),
	initialValues: {
		activeYN: true
	},
	disableColumnSelector: true,
	parseOnSaveError: (err, { id, api, values, isImport, action, onSuccess }) => {
		if (typeof err?.info === 'string' && err.info.startsWith('ExistWith')) {
			const valArr = err.info.replace('ExistWith_', '').split('_');
			const msg = strings.ExistWith.replaceAll('{0}', `<strong>${valArr[0] || ''}</strong>`).replaceAll(
				'{1}',
				`<strong>${valArr[1] || ''}</strong>`
			);
			Swal.fire({
				title: strings.Info,
				html: msg,
				icon: 'info',
				showCancelButton: true,
				confirmButtonText: strings.Yes,
				cancelButtonText: strings.Cancel,
				showLoaderOnDeny: true,
				allowOutsideClick: false,
				preConfirm: () => {
					const { code, assetId } = values;
					saveRecord({ id, api, values: { code, assetId, isMove: true }, isImport, action }).then(res => {
						if (typeof onSuccess === 'function') {
							onSuccess(res);
						}
					});
				}
			})
				.catch(({ status }) => {
					if (status === 404) {
						// Do Some Stuff
					}
				})
		}
	},
	columns: [
		{ header: 'Codes', field: 'code', required: true, width: 250 },
		{ header: 'Active', field: 'activeYN', type: 'boolean', hidden: true },
		{ header: 'InterfacedYN', field: 'interfacedYN', type: 'boolean', hidden: true, disabled: true },
		{ header: 'DeleteFlag', field: 'deleteFlag', type: 'boolean', hidden: true, disabled: true },
		{
			field: 'Delete',
			header: 'Delete',
			width: 150,
			type: 'action',
			isNotformfield: true,
			action: 'delete',
			renderCell: (params) => (
				<ActionIconButton
					onClick={() => params.colDef.deleteRow(params)}
					color="error"
					variant="contained"
					title={strings.Delete}
					size="small"
					disabled={params.row?.interfacedYN || consts.RoleCheck.includes(util?.getLoginData()?.roles[0])}
				>
					<DeleteIcon fontSize="inherit" />
				</ActionIconButton>
			)
		}
	]
});

export default model.createFormBase();
